import axios from "axios";

const URL_API_TICKET = process.env.VUE_APP_API_CONTENIDO;

export default {
  obtenerInformativos(id_sucursal, accion) {
    return axios.get(
      URL_API_TICKET + `system/getSystemInformatives/${id_sucursal}/${accion}`
    );
  },
  obtenerParametros(usuario) {
    return axios.get(URL_API_TICKET + `system/getSystemParameters/${usuario}`);
  },
  obtenerParametrosGenerales() {
    return axios.get(URL_API_TICKET + `content/getTicketParams`);
  },
};
